import { RiCheckLine } from "react-icons/ri";
import { StatusTag } from "src/components/DataDisplay/StatusTag";

export const PaidTag = () => (
  <StatusTag
    status={{
      label: "Paid",
      longLabel: "Paid",
      colorScheme: "green",
      icon: RiCheckLine,
    }}
  />
);
